function perc2color(value) {
	value = value / 100
	const hue = ((value) * 120).toString(10)
	return ['hsl(', hue, ', 100%, 50%)'].join('')
}

export {
	perc2color,
}
